import BaseService from './base.service';

class EmailTextService extends BaseService {
  get basePath() {
    return 'email-texts';
  }

  async create() {
    throw 'Not available';
  }

  async delete() {
    throw 'Not available';
  }
}

export default new EmailTextService();
